module.exports = __webpack_public_path__ + "img/rewolucyjna_stol.ff75ca8e.jpg";